import { normalizeAuthority } from "../utils/authority/Authority.js";
import { DataManager } from "../../core/data-manager.js";
import { ApiManager } from "../../core/api-manager.js";
import { entity_language } from "../entity_language.js";
import { toast } from "react-toastify";


export async function onUpdate(response, entity, data, id) {

    switch (entity){

        case 'user': {
            if(response.success !== 1) return;
            if(!data?.idAuthority?.id) return;
        
            normalizeAuthority(id);
            break;
        }

        case 'ticket': {
            if(response.success !== 1){
                toast.error('impossibile inviare notifica all\'utente || errorCode#000', {
                    position: 'bottom_right',
                    autoClose: true,
                    closeButton: true,
                });
                return;
            };

            const lastMod = await ApiManager.sendAuthenticatedRequest( '/custom/prev_ticket_state' , { 
                idTicket: id,
            });
            if(!lastMod || lastMod.success !== 1){
                console.log('onUpdateTicket', 'lastMod', lastMod);
                toast.error('impossibile inviare notifica all\'utente || errorCode#001', {
                    position: 'bottom_right',
                    autoClose: true,
                    closeButton: true,
                });
                return;
            }
            const lastStatus = lastMod?.prev_ticket_status;

            if(!lastStatus){
                console.log('onUpdateTicket', 'lastMod', lastMod);
                toast.error('impossibile inviare notifica all\'utente || errorCode#001', {
                    position: 'bottom_right',
                    autoClose: true,
                    closeButton: true,
                });
                return;
            };

            if(data.status.value === '5_OPEN'){
                console.log('onUpdateTicket', 'data.status === 5_OPEN', data.status);
                return;
            }
            if(lastStatus === data.status.value) {
                console.log('onUpdateTicket', 'lastStatus === data.status', lastStatus === data.status.value , lastStatus , data.status.value);
                return;
            }
            
            const label = entity_language?.labels?.ticket['status.options.' + data.status.value];

            if(!label){
                console.log('onUpdateTicket', 'label', label);
                toast.error('impossibile inviare notifica all\'utente || errorCode#003', {
                    position: 'bottom_right',
                    autoClose: true,
                    closeButton: true,
                });
                return;
            };

            console.log({'/custom/send_notification' : {
                title: 'La tua segnalazione è stata aggiornata',
                body: 'La segnalazione #' + id + ' è passata di stato a: ' + label,
                idTargetUser: data?.author?.id,
                data: {
                    "url" : "comunevicino://segnalazione/" + id
                }
            }});

            ApiManager.sendAuthenticatedRequest('/custom/send_notification', {
                title: 'La tua segnalazione è stata aggiornata',
                body: 'La segnalazione #' + id + ' è passata allo stato "' + label + '"',
                idTargetUser: data?.author?.id,
                clickAction: {
                    "url" : "comunevicino://segnalazione/" + id
                }
            }).then(response => {
                console.log({'/custom/send_notification' : response});
                if (response.success === 1) {
                    toast.success('notifica inviata con successo', {
                        position: 'bottom_right',
                        autoClose: true,
                        closeButton: true,
                    });
                }else{
                    toast.error('impossibile inviare notifica all\'utente || errorCode#004', {
                        position: 'bottom_right',
                        autoClose: true,
                        closeButton: true,
                    });
                }
            })

            break;
        }
    };

}